/**
 * Renders the backend `detail_grid` key/value pairs. Empty-safe.
 * @param {{ items?: { key: string, value: string }[] }} props
 */
export function DetailGrid({ items }) {
  const rows = items || [];
  return (
    <div className="overflow-hidden rounded-2xl border border-eorig-border bg-white shadow-eorig-card">
      <div className="border-b border-eorig-border bg-eorig-surface px-4 py-3">
        <h3 className="text-sm font-semibold text-eorig-ink">Detail grid</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[320px] border-collapse text-left text-xs sm:text-sm">
          <thead>
            <tr className="border-b border-eorig-border bg-eorig-surface">
              <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wide text-eorig-muted">
                Key
              </th>
              <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wide text-eorig-muted">
                Value
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map((row, ri) => (
                <tr
                  key={`${row.key}-${ri}`}
                  className="border-b border-eorig-border last:border-b-0"
                >
                  <td className="px-4 py-2.5 font-medium text-eorig-ink">
                    {row.key.replace(/_/g, ' ')}
                  </td>
                  <td className="px-4 py-2.5 tabular-nums text-eorig-ink/80">
                    {row.value}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2} className="px-4 py-8 text-center text-sm text-eorig-muted">
                  No detail rows available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
